const URL = {
    NO_PHOTO: 'widget/showroom/asset/non-photo.png',
};

export default URL;
